var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54973 20.5983L17.3467 20.5983C18.1019 20.5984 18.7689 20.1058 18.991 19.3839L21.3723 11.6439C21.5327 11.1225 21.4362 10.5559 21.1123 10.1169C20.7883 9.67794 20.2753 9.4187 19.7297 9.41827L13.7097 9.41827L13.7097 5.97826C13.7097 3.93748 12.6339 2.97342 11.3327 2.65866C11.0755 2.59826 10.8048 2.65869 10.5977 2.82272C10.3906 2.98675 10.2698 3.23642 10.2697 3.5006V6.83827L5.96973 11.9983",
    stroke: "#171A1F",
    strokeWidth: 2.064,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00982 10.27H2.56982L2.56982 20.59H6.00982L6.00982 10.27Z",
    stroke: "#171A1F",
    strokeWidth: 2.064,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.70474a7546b2a6c344da09ad91cb64aa.svg";
export { ForwardRef as ReactComponent };